import { render, staticRenderFns } from "./ShippingInsurancesTableMobile.vue?vue&type=template&id=c7ce9732&scoped=true"
import script from "./ShippingInsurancesTableMobile.vue?vue&type=script&lang=js"
export * from "./ShippingInsurancesTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ce9732",
  null
  
)

export default component.exports